import axios from "axios";

import {
    getAdminToken,
    getToken,
    saveToken,
    getSuperAdminToken,
    clearToken,
    clearSession,
    clearAdminToken,
} from "./auth";

const api = axios.create({ baseURL: '/api/' });

api.defaults.timeout = 10000;

const superAdminPaths = [
    "/plans",
    "/products",
    "/enterprises",
    "/managers",
    "/nfse",
    "/paymenthistory",
    "/sequences",
    "/national-nfse-settings",
    "/templateemail",
    "/boletos",
    "/superadmin-dashboard",
    "/scout-observability"
]

api.interceptors.request.use(async (config) => {
    let token = getToken()

    if (window.location.pathname === '/metrics')
        token = getAdminToken()
    if (superAdminPaths.includes(window.location.pathname))
        token = getSuperAdminToken()

    if (token)
        config.headers.Authorization = `Bearer ${token}`

    return config;
});

api.interceptors.response.use((response) => { return response },
    async function (err) {
        if (!err.response)
            return err;

        const originalRequest = err.config;

        if (err.response.status === 401) {
            // meta exists for 360dialog 401, we don't want to redo the request
            if (!(typeof err.response.data === 'object') || !('meta' in err.response.data)) {
                if (superAdminPaths.includes(window.location.pathname))
                    document.location.href = '/superadmin';
                else {
                    clearSession()
                    clearToken()
                    clearAdminToken()

                    document.location.href = window.location.pathname === "/metrics"
                        ? "/metrics"
                        : "/"
                }
            }
        }
        else if (err.response.status === 502)
            return setTimeout(()=>api(originalRequest), 5000);

        return err.response;
    }
);

export default api;
